import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import EventBus from "../../utils/EventBus";
import CUSTOMERAPI from "../../Api/customer";

// Thunk for updating customer subscription
export const updateCustomerSubscription = createAsyncThunk(
  "subscription/updateCustomerSubscription",
  async ({ id, subscriptionPlan}, thunkAPI) => {
    try {
      const response = await CUSTOMERAPI.updateCustomerSubscription(id,subscriptionPlan);
      const message = response.message;
      thunkAPI.dispatch(setMessage(message));

      return response.data;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage(message));
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        EventBus.dispatch("logout");
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState: {
    updatedCustomer: [], 
    loading: false,
    error: null,
  },
 
  
  extraReducers: (builder) => {
    builder
      .addCase(updateCustomerSubscription.fulfilled, (state, action) => {
        state.updatedCustomer = action.payload; 
        state.loading = false;
      })
      .addCase(updateCustomerSubscription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetSubscriptionState } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
